"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _courseItem = _interopRequireDefault(require("@/components/courseItem.vue"));
var _xnfzItem = _interopRequireDefault(require("@/components/xnfzItem.vue"));
var _courseTwo = _interopRequireDefault(require("@/components/courseTwo.vue"));
var _courseItemResource = _interopRequireDefault(require("@/components/courseItemResource.vue"));
var _winCourse = _interopRequireDefault(require("@/components/winCourse.vue"));
var _banner = _interopRequireDefault(require("@/components/banner.vue"));
var _search = _interopRequireDefault(require("@/components/search.vue"));
var _nav = _interopRequireDefault(require("@/components/nav.vue"));
var _public = require("@/api/public/public");
var _news = require("@/api/news/news");
var _index = require("@/api/virtualSimulationClass/index");
var _recommendCourse = require("@/api/recommendCourse");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import "../index.less";
var _default = exports.default = {
  components: {
    CourseItem: _courseItem.default,
    XnfzItem: _xnfzItem.default,
    Banner: _banner.default,
    Search: _search.default,
    WinCourse: _winCourse.default,
    courseItemResource: _courseItemResource.default,
    CourseTwo: _courseTwo.default,
    Nav: _nav.default
  },
  filters: {
    date: function date(val) {
      return val.slice(0, 10);
    }
  },
  data: function data() {
    return {
      actNum: 0,
      curType: 0,
      listBookData: [],
      listData: [],
      //moni
      newsItem: [],
      CountryList: [],
      newTypeList: [],
      tjkList: [],
      zykList: [],
      courseList: [],
      openCourseList: [],
      virtualList: [],
      teacherList: [],
      query: {
        isPut: 1,
        pageNum: 1,
        pageSize: 8,
        provinceId: this.$store.getters.provinceId,
        courseName: "",
        majorName: ''
      }
    };
  },
  methods: {
    toSsearch: function toSsearch(e) {
      // console.log("dianji", e);
      this.query.courseName = e.courseName;
      if (e.majorName == '全部') {
        this.query.majorName = '';
      } else {
        this.query.majorName = e.majorName;
      }
      this.getCourseList();
      this.getZykList();
      // this.getOpenCourseList();
      // this.getList();
      // this.getTextbookList();
      this.getCountryList();
      // this.getTeacherList()
      this.getTjList();
    },
    toSecond: function toSecond(url) {
      this.$router.push(url);
    },
    // 专业与课程切换
    tabChange: function tabChange(index) {
      this.actNum = index;
      // alert('111')
    },
    // 搜索
    handleSearch: function handleSearch() {},
    // 获取新闻类型
    getNewsType: function getNewsType() {
      var _this = this;
      (0, _news.newsTypeByCode)({
        param: this.prCode
      }).then(function (res) {
        if (res.data.length > 0) {
          _this.newTypeList = res.data;
          _this.findNews(_this.newTypeList[0].id);
        }
      });
    },
    // 获取首页精品在线课程
    getCourseList: function getCourseList() {
      var _this2 = this;
      (0, _index.getReceptionList)({
        majorName: this.query.majorName,
        courseName: this.query.courseName,
        courseType: "1",
        schoolId: "",
        pageNum: 1,
        pageSize: 8,
        showStatus: 1
      }).then(function (res) {
        _this2.courseList = res.rows;
      });
    },
    getCountryList: function getCountryList() {
      var _this3 = this;
      //国家规划教材数字课程
      (0, _index.getReceptionList)({
        majorName: this.query.majorName,
        courseName: this.query.courseName,
        pageNum: 1,
        pageSize: 8,
        projectLevel: "",
        courseTypeList: ["3", "2", "6", "4", "5"],
        schoolId: ''
      }).then(function (res) {
        _this3.CountryList = res.rows;
      });
    },
    //获取专业资源库
    getZykList: function getZykList() {
      var _this4 = this;
      (0, _index.zyzykList)({
        onState: 1,
        pageNum: 1,
        pageSize: 8,
        majorName: this.query.majorName,
        keyWord: this.query.courseName
      }).then(function (res) {
        _this4.zykList = res.rows;
      });
    },
    getOpenCourseList: function getOpenCourseList() {
      var _this5 = this;
      (0, _index.getReceptionList)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
        courseName: this.query.courseName
      }, "courseName", this.query.courseName), "courseType", ""), "schoolId", ""), "pageNum", 1), "pageSize", 8), "courseTypeList", ["2", "3", "4", "5", "6"]), "provinceId", this.$store.getters.provinceId), "showStatus", 1), "majorName", this.query.majorName)).then(function (res) {
        var data = res.data;
        _this5.openCourseList = data.rows;
      });
    },
    tabs: function tabs(index, id) {
      this.curType = index;
      this.newsItem = [];
      this.findNews(id);
    },
    // 根据不同类型ID查询不同省份新闻
    findNews: function findNews(id) {
      var _this6 = this;
      (0, _news.newsListByCodeAndType)({
        code: this.prCode,
        newsTypeId: id,
        pageNum: 1,
        pageSize: 8
      }).then(function (res) {
        _this6.newsItem = res.data.list;
      });
    },
    // 更多
    lookMoreBtn: function lookMoreBtn(v) {
      this.$router.push(v);
    },
    // 查看详情
    lookDetail: function lookDetail(e) {
      if (e.newsUrl) {
        window.open(e.newsUrl);
      } else {
        this.$router.push({
          path: "/newsDetail",
          query: {
            newsType: "news",
            curIndex: this.curType,
            id: e.id
          }
        });
      }
    },
    getTjList: function getTjList() {
      var _this7 = this;
      (0, _recommendCourse.recommendList)({
        pageNum: 1,
        pageSize: 8,
        // status:4,
        keyWord: this.query.courseName
      }).then(function (res) {
        _this7.tjkList = res.rows;
      });
    }
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return this.getTjList();
          case 1:
            _context.next = 2;
            return this.getCourseList();
          case 2:
            _context.next = 3;
            return this.getZykList();
          case 3:
            _context.next = 4;
            return this.getCountryList();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }()
};